<p-dialog [modal]="true" [closable]="true" [style.height]="600" [(visible)]="display" (onAfterHide)="cancel()"
  [closeOnEscape]="false" header="{{ title }}" (onHide)="cancel()">
  <div class="user-confirmation-blocking" [hidden]="!blockDialog">
    <span>Loading...</span>
  </div>
  <div class="user-confirmation-content {{ action | lowercase }}">
    <div class="user-confirmation-title">
      <span [hidden]="action != Status.AUTHORITY_USER_APPROVED">
        Please review the details of your request and confirm all entries prior to accepting the authority. Something
        not right? Proceed to
        cancel the request.
      </span>
      <span [hidden]="action != Status.RELEASE_USER_APPROVED">
        Please review the details of your request and confirm all entries prior to accepting the release. Something not
        right? Proceed to
        cancel the release.
      </span>
      <span [hidden]="action != Source.TRANSFER_TO_PAPER">
        Please review the details of your request and confirm that all entries have been accurately and completely
        transcribed to an EC-1
        form. Once confirmed the authority will no longer be available to view from ATAM.
      </span>
      <span [hidden]="action != Status.CHANGE_USER_APPROVED">
        Please review the details of your request and confirm all entries prior to accepting the modification to
        authority. Something not
        right? Proceed to cancel the request.
      </span>
    </div>
    <div class="user-confirmation-lines"
      [ngClass]="{ 'mutually-exclusive-selection': userConfirmationItem.confirmType === 'ME' }"
      *ngFor="let userConfirmationItem of userConfirmationList">
      <div class="user-confirmation-line-title">{{ userConfirmationItem.title }}</div>
      <div class="user-confirmation-line-text entry-validation-{{ userConfirmationLabel.accepted }}"
        *ngFor="let userConfirmationLabel of userConfirmationItem.userConfirmationLabelList"
        (click)="toggleUserConfirmationLabelStatus(userConfirmationItem, userConfirmationLabel)">
        <span title="{{ userConfirmationLabel.value }}">{{ userConfirmationLabel.confirmMessage }}</span>
        <i class="csx-common_check" [hidden]="!userConfirmationLabel.accepted"></i>
        <button type="button" pButton label="{{ userConfirmationItem.confirmType === 'ME' ? 'Select' : 'Confirm' }}"
          class="p-button-outlined bg-white smaller" [hidden]="userConfirmationLabel.accepted"></button>
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="cancel()" label="Cancel" class="p-button-outlined md:w-16rem"></button>
    <button type="button" pButton [disabled]="!allAccepted" class="md:ml-1 md:w-16rem" label="{{ confirmBtnTitle }}"
      (click)="accept()"></button>
  </p-footer>
</p-dialog>